/* eslint-disable max-statements */
import Excel from "exceljs"
import { cellConfig } from "../../config/cell"
import { columnsConfig } from "../columnsConfig"
import {
  SafetiesDetailExcelSheetType,
  SafetyInfoHeaderType,
} from "../../../../../../../../models/detail/export"
import { Translate } from "../../../../../../../../../../../constant/Translate"

const { EXPORT_EP0205 } = Translate

export const worksheetConfig = async (
  data: SafetiesDetailExcelSheetType[],
  header: SafetyInfoHeaderType,
  workbook: Excel.Workbook,
) => {
  const worksheet = workbook.addWorksheet(EXPORT_EP0205)
  columnsConfig(data, header, worksheet)

  for (let index = 0; index < data.length; index++) {
    const item = data[index]
    // 7
    worksheet.getCell(`$A${index * 4 + 7}`).value = item.index
    worksheet.getCell(`$B${index * 4 + 7}`).value = item.safetyStatusName
    worksheet.getCell(`$C${index * 4 + 7}`).value = item.proxyResponser
    worksheet.getCell(`$D${index * 4 + 7}`).value = item.safetyResponseDate
    worksheet.getCell(`$E${index * 4 + 7}`).value = item.fullNameKanji
    worksheet.getCell(`$F${index * 4 + 7}`).value = item.dispatchTypeDetailName
    worksheet.getCell(`$G${index * 4 + 7}`).value = item.locationPhoneNumber1
    worksheet.getCell(`$H${index * 4 + 7}`).value = item.urgentContactHome
    worksheet.getCell(`$I${index * 4 + 7}`).value = item.personCompanyPosition
    worksheet.getCell(`$J${index * 4 + 7}`).value =
      item.urgentAffiliationContact
    worksheet.getCell(`$K${index * 4 + 7}`).value = item.insuranceCompanyName
    worksheet.getCell(`$L${index * 4 + 7}`).value =
      item.insuranceCompanyPhoneNumber
    worksheet.getCell(`$M${index * 4 + 7}`).value = item.insuranceTicketNumber
    worksheet.getCell(`$N${index * 4 + 7}`).value = item.insuranceSonsignor
    // 7 + 1n
    worksheet.getCell(`$G${index * 4 + 8}`).value = item.locationPhoneNumber2
    // 7 + 2n
    worksheet.getCell(`$E${index * 4 + 9}`).value = item.fullNameRomaji
    worksheet.getCell(`$F${index * 4 + 9}`).value = item.passportNumber
    worksheet.getCell(`$G${index * 4 + 9}`).value = item.satellitePhoneNumber
    worksheet.getCell(`$H${index * 4 + 9}`).value = item.urgentContactName
    worksheet.getCell(`$J${index * 4 + 9}`).value =
      item.urgentAffiliationContactName
    // 7 + 3n
    worksheet.getCell(`$G${index * 4 + 10}`).value = `${item.personPhoneNumber}`
  }

  data.forEach((_, index) => {
    const dataMergeCells = (index + 1) * 4 + 3
    worksheet.mergeCells(`$A$${dataMergeCells}:$A${dataMergeCells + 3}`)
    worksheet.mergeCells(`$B$${dataMergeCells}:$B${dataMergeCells + 3}`)
    worksheet.mergeCells(`$C$${dataMergeCells}:$C${dataMergeCells + 3}`)
    worksheet.mergeCells(`$D$${dataMergeCells}:$D${dataMergeCells + 3}`)
    worksheet.mergeCells(`$E$${dataMergeCells}:$E${dataMergeCells + 1}`)
    worksheet.mergeCells(`$E$${dataMergeCells + 2}:$E${dataMergeCells + 3}`)
    worksheet.mergeCells(`$F$${dataMergeCells}:$F${dataMergeCells + 1}`)
    worksheet.mergeCells(`$F$${dataMergeCells + 2}:$F${dataMergeCells + 3}`)
    worksheet.mergeCells(`$H$${dataMergeCells}:$H${dataMergeCells + 1}`)
    worksheet.mergeCells(`$H$${dataMergeCells + 2}:$H${dataMergeCells + 3}`)
    worksheet.mergeCells(`$I$${dataMergeCells}:$I${dataMergeCells + 3}`)
    worksheet.mergeCells(`$J$${dataMergeCells}:$J${dataMergeCells + 1}`)
    worksheet.mergeCells(`$J$${dataMergeCells + 2}:$J${dataMergeCells + 3}`)
    worksheet.mergeCells(`$K$${dataMergeCells}:$K${dataMergeCells + 3}`)
    worksheet.mergeCells(`$L$${dataMergeCells}:$L${dataMergeCells + 3}`)
    worksheet.mergeCells(`$M$${dataMergeCells}:$M${dataMergeCells + 3}`)
    worksheet.mergeCells(`$N$${dataMergeCells}:$N${dataMergeCells + 3}`)
  })

  cellConfig(worksheet, EXPORT_EP0205)
}
